/* oxlint-disable react/react-compiler -- Existing code is not yet compatible with React Compiler checks. */
import * as React from 'react';

/**
 * Return a reference that always hold the value of the last render.
 * @deprecated Setting a ref value during render is an anti-pattern.
 * Use `useLiveRef` or `useEventCallback` instead.
 */
export function useLatestRef<T>(value: T): React.MutableRefObject<T> {
    const ref = React.useRef(value);
    ref.current = value;

    return ref;
}
